import { useState } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { TabList } from 'dibs-elements/exports/TabList';
import { TabPanels } from 'dibs-elements/exports/TabPanels';
import { TabProvider } from 'dibs-elements/exports/TabProvider';
import { SbSharedCreatorsResultContainer } from '../SbSharedCreatorsResultContainer/SbSharedCreatorsResultContainer';
import PropTypes from 'prop-types';

import { useFragment, graphql } from 'react-relay';

const getVertical = vertical => {
    switch (vertical) {
        case 'furniture':
            return (
                <FormattedMessage
                    id="sb.SbSharedCategoryTabs.verticalFurniture"
                    defaultMessage="Furniture"
                />
            );
        case 'jewelry':
            return (
                <FormattedMessage
                    id="sb.SbSharedCategoryTabs.verticalJewelry"
                    defaultMessage="Jewelry"
                />
            );
        case 'fashion':
            return (
                <FormattedMessage
                    id="sb.SbSharedCategoryTabs.verticalFashion"
                    defaultMessage="Fashion"
                />
            );
        case 'art':
        default:
            return (
                <FormattedMessage id="sb.SbSharedCategoryTabs.verticalArt" defaultMessage="Art" />
            );
    }
};

export const SbSharedCategoryTabs = ({
    viewer: viewerRef,
    creatorRootPage: creatorRootPageRef,
    itemSearch: itemSearchRef,
}) => {
    const viewer = useFragment(
        graphql`
            fragment SbSharedCategoryTabs_viewer on Viewer {
                ...SbSharedCreatorsResultContainer_viewer
            }
        `,
        viewerRef
    );
    const itemSearch = useFragment(
        graphql`
            fragment SbSharedCategoryTabs_itemSearch on ItemSearchQueryConnection {
                ...SbSharedCreatorsResultContainer_itemSearch
            }
        `,
        itemSearchRef
    );

    const creatorRootPage = useFragment(
        graphql`
            fragment SbSharedCategoryTabs_creatorRootPage on CreatorRootPage {
                verticals
                verticalsUriRef
                verticalItems {
                    list {
                        ...SbSharedCreatorsResultContainer_items
                    }
                }
            }
        `,
        creatorRootPageRef
    );

    const tabOrder = creatorRootPage?.verticals || [];
    const [activeTab, setActiveTab] = useState(tabOrder?.[0]);

    const tabs = {};
    tabOrder.forEach(
        (tab, idx) =>
            (tabs[tab] = (
                <SbSharedCreatorsResultContainer
                    viewer={viewer}
                    items={creatorRootPage?.verticalItems?.[idx]?.list}
                    itemSearch={itemSearch}
                    vertical={getVertical(tab)}
                    link={creatorRootPage?.verticalsUriRef?.[idx]}
                />
            ))
    );

    return Object.keys(tabs).length > 1 ? (
        <TabProvider activeTab={activeTab} setActiveTab={setActiveTab}>
            <TabList indicatorPadding="small" fullWidth>
                {tabOrder.map(name => [name, getVertical(name)])}
            </TabList>
            <TabPanels>{tabOrder.map(name => [name, tabs[name]])}</TabPanels>
        </TabProvider>
    ) : (
        <div>{tabs[tabOrder[0]]}</div>
    );
};

SbSharedCategoryTabs.propTypes = {
    viewer: PropTypes.object.isRequired,
    creatorRootPage: PropTypes.object,
    itemSearch: PropTypes.object,
};
